/* eslint-disable array-callback-return */
import React, { useState } from 'react';
import { NavigationDisplayItems } from './navigation.displayItems';
import { FaPlus } from 'react-icons/fa';
import { LinkNew } from '../link/link.New';
import { useDispatch } from 'react-redux';
import { setOpenModales } from '../../store/global';
import { NavigationView } from './navigation.View';
import { useParams } from 'react-router';

export const NavigationSection = props => {
  const {
    sectionId,
    section,
    itemsInSection,
    setRenderedSections,
    renderedSections,
    isSubLevel,
  } = props;

  const params = useParams();

  const [collapse, setCollapse] = useState(true);
  const [newRenderedSections, setNewRenderedSections] = useState([]);

  const dispatch = useDispatch();

  const setLocalRenderedSections = newValue => {
    if (setRenderedSections) {
      setRenderedSections(newValue);
    } else {
      setNewRenderedSections(newValue);
    }
  };

  const handleCollapse = () => {
    if (collapse) {
      setLocalRenderedSections([
        ...(renderedSections ?? newRenderedSections),
        sectionId,
      ]);
    }
    if (!collapse && sectionId !== params.id) {
      const tmpRenderedSections = [
        ...(renderedSections ?? newRenderedSections),
      ];
      const sectionIndex = newRenderedSections.findIndex(
        id => id === sectionId
      );
      tmpRenderedSections.splice(sectionIndex);
      setLocalRenderedSections(tmpRenderedSections);
    }

    setCollapse(!collapse);
  };

  const displaySimpleList = () => {
    return itemsInSection?.map(item => {
      if (item?._id) {
        return (
          <NavigationDisplayItems
            key={item?._id}
            displayItem={item}
          />
        );
      }
    });
  };

  const classNameHeader =
    props.classNameHeader ??
    `${
      section?.color ? 'bg-' + section?.color : 'bg-primary-d'
    } border-t border-main flex items-center gap-1 bg-opacity-40 px-1 uppercase cursor-pointer transition hover:opacity-50`;

  return (
    <div key={sectionId}>
      {sectionId !== params.id && (
        <div
          key={sectionId}
          className={
            classNameHeader +
            (isSubLevel && !collapse ? ' bg-contrast bg-opacity-25' : '')
          }
        >
          <div
            onClick={() => handleCollapse()}
            className={props.classNameTitle ?? ' flex-1 text-xs py-05 '}
          >
            {section?.label}
          </div>
          {!isSubLevel && (
            <div
              className='text-contrast text-opacity-50 transition hover:text-opacity-100'
              onClick={() =>
                dispatch(
                  setOpenModales({ id: 'addLink' + sectionId, open: true })
                )
              }
            >
              <FaPlus size={10} />
            </div>
          )}
          <LinkNew itemId={sectionId} />
        </div>
      )}
      {!collapse && (
        <>
          {section?.view && !props.hideSection ? (
            <NavigationView
              parentId={section?._id}
              viewId={section?.view}
              itemsInSection={itemsInSection}
              classNameHeader={`flex items-center justify-end gap-1 px-1 py-02 cursor-pointer transition hover:opacity-50 border-t border-contrast border-opacity-25`}
              classNameTitle='text-contrast text-opacity-50 text-xs flex-1 text-right'
              isSubLevel={true}
              setRenderedSections={setLocalRenderedSections}
              renderedSections={renderedSections ?? newRenderedSections}
            />
          ) : (
            displaySimpleList()
          )}
        </>
      )}

      {sectionId === params.id && displaySimpleList()}
    </div>
  );
};
